import { authApi } from './apiManager';

interface UserProfileResponse {
  id: number;
  name: string;
  threeYearSummary: string;
}

class OnboardingService {
  async getUserProfile(userId: string | number): Promise<UserProfileResponse> {
    try {
      const response = await authApi.getUserProfile(userId);
      
      if (!response.success) {
        throw new Error(response.error || 'Failed to get user profile');
      }

      const data = response.data;
      return {
        id: data.id,
        name: data.name,
        threeYearSummary: data.threeYearSummary
      };
    } catch (error) {
      console.error('Get user profile failed:', error);
      throw error;
    }
  }
}

export const onboardingService = new OnboardingService();
export type { UserProfileResponse };
